import React from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { withLoading } from '../../../../../../redux-modules/loading-overlay';
import HomeAddress from './HomeAddress';
import RepresentativeList from './RepresentativeList';
import ContinuePage from './ContinuePage';

class Representatives extends React.Component {
  static promises = {
    includePromises: [
      {
        meta: { namespace: 'legislators' },
      },
    ],
  };
  state = {
    redirectUrl: null,
  };

  routes = {
    HomeAddress: '',
    RepList: 'results',
    Continue: 'continue',
  };

  // will need to update on refresh to load form data (cust AND org) ENGA-1098
  // will need to update on location change or routing will NOT WORK in RR4 ENGA-1149
  // otherwise it shouldn't because on 400 response from LEGS, it will call infinitely ENGA-1018
  shouldComponentUpdate(nextProps) {
    return (
      !!(
        (!this.props.currentCustomer && nextProps.currentCustomer) ||
        (!this.props.currentOrganization && nextProps.currentOrganization)
      ) || this.props.location.pathname !== nextProps.location.pathname
    );
  }

  toggleView = newView => {
    const url = this.routes[newView];
    this.props.history.push(
      this.sanitizeUrl(`${this.props.match.path}/${this.props.url}/${url}`)
    );
  };

  goForward = () => {
    // this should not normally need to happen but is necessary to use router and wizard engine together
    this.props.setActiveIndex(this.props.activeIndex + 1);
  };

  goBack = () => {
    // this should not normally need to happen but is necessary to use router and wizard engine together
    this.props.setActiveIndex(this.props.activeIndex - 1);
  };

  sanitizeUrl = url => {
    return url.replace('/account/onboarding/', '');
  };

  render() {
    const childProps = {
      ...this.props,
      toggleView: this.toggleView,
      goBack: this.goBack,
      goForward: this.goForward,
    };

    return (
      <Switch>
        <Route
          path={this.sanitizeUrl(`${this.props.match.path}/${this.props.url}/${this.routes.RepList}`)}
          component={() => <RepresentativeList {...childProps} />}
        />
        <Route
          path={this.sanitizeUrl(`${this.props.match.path}/${this.props.url}/${this.routes.Continue}`)}
          component={() => <ContinuePage {...childProps} />}
        />
        <Route render={() => <HomeAddress {...childProps} />} />
      </Switch>
    );
  }
}

export default withRouter(withLoading(Representatives));



// WEBPACK FOOTER //
// ./src/App/account/components/Onboarding/Steps/Representatives/index.js